import { orchestrator } from 'satcheljs';
import {
    showEmailReminderDialog,
    hideEmailReminderDialog,
    setShowDialog,
} from '../actions/emailReminderDialogActions';
import { resetNewReminderIdMap } from '../actions/newReminderIdMapActions';
import { discardDraftInboxReminder } from '../actions/draftInboxReminderActions';

orchestrator(showEmailReminderDialog, () => {
    // Show email reminder dialog
    setShowDialog(true /* shouldShow */);
});

orchestrator(hideEmailReminderDialog, () => {
    // 1. Hide email reminder dialog
    setShowDialog(false /* shouldShow */);

    // 2. Discard any unsaved changes
    discardDraftInboxReminder();

    // 3. Clear the new reminder id map
    resetNewReminderIdMap();
});
